import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Box,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EditIcon from '@mui/icons-material/Edit';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ReceiptIcon from '@mui/icons-material/LibraryBooks';

const HomePage = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Criar Cliente',
      description: 'Adicionar novo cliente',
      icon: <PersonAddIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
      path: '/costumers/add'
    },
    {
      title: 'Atualizar Cliente',
      description: 'Buscar e editar cliente existente',
      icon: <EditIcon sx={{ fontSize: 40, color: '#388e3c' }} />,
      path: '/costumers/list'
    },
    {
      title: 'Criar Carro',
      description: 'Adicionar novo veículo',
      icon: <DirectionsCarIcon sx={{ fontSize: 40, color: '#f57c00' }} />,
      path: '/cars/add'
    },
    {
      title: 'Atualizar Carro',
      description: 'Buscar e editar veículo existente',
      icon: <DirectionsCarIcon sx={{ fontSize: 40, color: '#7b1fa2' }} />,
      path: '/cars/list'
    },
    {
      title: 'Criar Ordem de Serviço',
      description: 'Nova ordem de serviço',
      icon: <PostAddIcon sx={{ fontSize: 40, color: '#0288d1' }} />,
      path: '/service-orders/add'
    },
    {
      title: 'Atualizar Ordem de Serviço',
      description: 'Buscar e editar ordem de serviço',
      icon: <ReceiptIcon sx={{ fontSize: 40, color: '#0288d1' }} />,
      path: '/service-orders/search'
    }
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Nuovauto
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom align="center" color="text.secondary">
          Sistema de Gestão
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {menuItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4
                }
              }}
            >
              <CardActionArea 
                onClick={() => handleCardClick(item.path)}
                sx={{ height: '100%', p: 2 }}
              >
                <CardContent sx={{ textAlign: 'center', height: '100%' }}>
                  <Box sx={{ mb: 2 }}>
                    {item.icon}
                  </Box>
                  <Typography variant="h6" component="h3" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6, mb: 2 }}>
        <Paper elevation={1} sx={{ p: 3, bgcolor: 'grey.50' }}>
          <Typography variant="body2" align="center" color="text.secondary">
            Selecione uma das opções acima para começar
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default HomePage;